import { Route, BrowserRouter as Router, Routes, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Login from './components/Login';
import Register from './components/Register';
import ProtectedRoute from './components/ProtectedRoute';
import { ApplicationProvider } from './context/ApplicationContext';
import { AuthProvider } from './context/AuthContext';
import { DevToolsProvider } from './context/DevToolsContext';
import { ErrorProvider } from './context/ErrorContext';
import AppRoutes from './app/routes';
import PanelLayout from './panel/PanelLayout';
import DevToolsPanel from './components/DevToolsPanel';
import ApplicationDetail from './components/ApplicationDetail';
import Applications from './components/Applications';
import AppScreensPage from './components/AppScreensPage';
import RevenueCatPage from './components/RevenueCatPage';
import AppleSearchAdsPage from './components/AppleSearchAdsPage';
import AppleSearchAdsAccountPage from './components/AppleSearchAdsAccountPage';
import ASOKeywordsPage from './components/ASOKeywordsPage';
import AppASOPage from './components/AppASOPage';
import AppScreensVersionRedirect from './components/AppScreensVersionRedirect';
import AppStoreSettingsPage from './components/AppStoreSettingsPage';
import JobDetail from './components/JobDetail';
import Jobs from './components/Jobs';
import Secrets from './components/Secrets';
import TeamUsers from './components/TeamUsers';
import SystemDetailsPage from './components/SystemDetailsPage';
import SystemLoadPage from './components/SystemLoadPage';
import VersionEditPage from './components/VersionEditPage';
import StoragePage from './app/pages/StoragePage';
import ProfilePage from './app/pages/ProfilePage';
import AILocalization from './components/tools/AILocalization';
import PlanPurchasePage from './app/pages/PlanPurchasePage';
import CheckoutSuccessPage from './app/pages/CheckoutSuccessPage';
import CreditsPage from './components/CreditsPage';
import PublisherTrackingPage from './components/PublisherTrackingPage';
import PublisherDetailPage from './components/PublisherDetailPage';

function App() {
  return (
    <DevToolsProvider>
      <Router>
        <AuthProvider>
          <ErrorProvider>
            <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
              <ScrollToTop />
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route
                  path="/panel"
                  element={
                    <ProtectedRoute>
                      <ApplicationProvider>
                        <PanelLayout />
                      </ApplicationProvider>
                    </ProtectedRoute>
                  }
                >
                  <Route index element={<DevToolsPanel />} />
                  <Route path="applications" element={<Applications />} />
                  <Route path="applications/:id" element={<ApplicationDetail />} />
                  <Route path="applications/:appId/app-screens" element={<AppScreensPage />} />
                  <Route path="applications/:appId/revenuecat" element={<RevenueCatPage />} />
                  <Route path="applications/:appId/apple-search-ads" element={<AppleSearchAdsPage />} />
                  <Route path="applications/:appId/aso" element={<AppASOPage />} />
<Route path="applications/:appId/pricing" element={<AppStoreSettingsPage />} />
                  <Route path="applications/:appId/availability" element={<AppStoreSettingsPage />} />
                  <Route path="jobs" element={<Jobs />} />
                  <Route path="jobs/:id" element={<JobDetail />} />
                  <Route path="secrets" element={<Secrets />} />
                  <Route path="team-users" element={<TeamUsers />} />
                  <Route path="system-details" element={<Navigate to="overview" replace />} />
                  <Route path="system-details/overview" element={<SystemLoadPage />} />
                  <Route path="system-details/load" element={<Navigate to="../overview" replace />} />
                  <Route path="system-details/memberships" element={<SystemDetailsPage />} />
                  <Route path="applications/:appId/versions/:versionId/app-screens" element={<AppScreensVersionRedirect />} />
                  <Route path="applications/:appId/versions/:versionId/:tab?" element={<VersionEditPage />} />
                  <Route path="storage" element={<StoragePage />} />
                  <Route path="aso" element={<ASOKeywordsPage />} />
<Route path="publishers" element={<PublisherTrackingPage />} />
                  <Route path="publishers/:id" element={<PublisherDetailPage />} />
                  <Route path="apple-search-ads" element={<AppleSearchAdsAccountPage />} />
                  <Route path="localization" element={<AILocalization />} />
                  <Route path="profile" element={<ProfilePage />} />
                  <Route path="credits" element={<CreditsPage />} />
                  <Route path="upgrade" element={<PlanPurchasePage />} />
                </Route>
                <Route path="/checkout" element={<ProtectedRoute><CheckoutSuccessPage /></ProtectedRoute>} />
                <Route path="/credits" element={<ProtectedRoute><CreditsPage /></ProtectedRoute>} />
                <Route path="*" element={<AppRoutes />} />
              </Routes>
            </div>
          </ErrorProvider>
        </AuthProvider>
      </Router>
    </DevToolsProvider>
  );
}

export default App;
